import React from 'react';
import { Box } from '@mui/material';
import { node } from 'prop-types';

const Company = ({ headline }) => (
  <Box
    sx={{
      height: '22px',
      mb: '15px',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSize: '15px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '-0.5px',
      color: '#738195',
      lineHeight: 1.47,
    }}
  >
    {headline}
  </Box>
);
Company.propTypes = {
  headline: node.isRequired,
};

export default Company;
